import {defineStore} from 'pinia'

export const usePlatformPackageStore = defineStore({
    id: 'platform_package',
    state: () => ({
        platform_packages: [],
        platform_package: null,
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 20,
        },
    }),
    actions: {
        index() {
            this.loading = true
            const params = {
                page: this.serverOptions.page + 1,
                size: this.serverOptions.rows,
                rows: this.serverOptions.rows,
            }
            return this.apiClient.get('/platform_packages', {params}).then(({data}) => {
                this.platform_packages = data.platform_packages || data.packages || []
                this.itemLength = data.itemLength ?? data.totalRecords ?? this.platform_packages.length
                return {data}
            }).finally(() => {
                this.loading = false
            })
        },
        show(id) {
            return this.apiClient.get(`/platform_packages/${id}`).then(({data}) => {
                this.platform_package = data.platform_package || data.package
                return {data}
            })
        },
        create(platform_package) {
            return this.apiClient.post('/platform_packages', {platform_package})
        },
        update(id, platform_package) {
            return this.apiClient.put(`/platform_packages/${id}`, {platform_package})
        },
        destroy(id) {
            return this.apiClient.delete(`/platform_packages/${id}`).then(({data}) => {
                this.platform_packages = this.platform_packages.filter((platformPackage) => platformPackage.id !== id)
                this.itemLength = Math.max(0, this.itemLength - 1)
                return {data}
            })
        },
    },
})
